import { classNames, loadYoutubeIframe, selectors, videoHasAudio } from './modules/utils';

window.addEventListener('load', () => {
	// Handle internal videos.
	document.querySelectorAll(selectors.internalVideoContainer).forEach((el) => {
		displayAudioTrigger(el.querySelector(selectors.videoElement) as HTMLVideoElement);
	});

	// Handle external videos.
	document.querySelectorAll(selectors.externalVideoContainer).forEach((el) => {
		el.addEventListener('click', () => {
			if (el.classList.contains(classNames.videoBlocked)) {
				loadYoutubeIframe(el);
			}
		});
	});
});

const displayAudioTrigger = (video: HTMLVideoElement) => {
	if (!video.hasAttribute('controls') && videoHasAudio(video)) {
		const audioTrigger = document.createElement('div');
		audioTrigger.classList.add('video__audio-trigger', classNames.muted);

		(video.parentNode as HTMLElement).appendChild(audioTrigger);
		audioTrigger.addEventListener('click', () => {
			video.muted = !video.muted;
			audioTrigger.classList.toggle(classNames.muted);
		});
	}
};

// Listen for color scheme changes
document.addEventListener('colorModeChange', (e) => {
	if (!(e instanceof CustomEvent)) return;
	document.querySelectorAll(selectors.videoConsent).forEach((el) => {
		el.setAttribute('data-color-scheme', e.detail);
	});
});
